import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=30a7f53c&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=30a7f53c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a7f53c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30a7f53c')) {
      api.createRecord('30a7f53c', component.options)
    } else {
      api.reload('30a7f53c', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=30a7f53c&scoped=true&", function () {
      api.rerender('30a7f53c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-26MWb6Cu2sH5d/JS/comp/PopupBox.vue"
export default component.exports